"use client";

import React from "react";
import CtaBand from "@/components/common/CtaBand";
import { useLanguage } from "@/hooks/useLanguage";
import { pick, type Lang } from "@/lib/i18n";
import { COMMON } from "@/lib/commonCopy";
interface EngineeringConsultationCtaCopy {
  eyebrow: string;
  heading: string;
  lead: string;
  secondaryLabel: string;
  note: string;
}
const copyData: Record<Lang, EngineeringConsultationCtaCopy> = {
  en: {
    eyebrow: "Filtration Engineering Support",
    heading: "Request a Quote or Consult Our Engineering Team",
    lead: "Discuss wire mesh aperture tolerances, custom weave types, multilayer sintered configurations, or volume delivery schedules directly with our filtration specialists.",
    secondaryLabel: "Contact Our Team",
    note: "Manufactured with reference to ISO 9044 and ASTM E2016 standards."
  },
  zh: {
    eyebrow: "工业过滤工程支持",
    heading: "获取报价或与我们的过滤工程团队技术咨询",
    lead: "就金属丝网孔径公差、定制编织结构、多层烧结网规格及批量供应计划，直接与我们的工业技术专家沟通选型与工艺细节。",
    secondaryLabel: "联系我们",
    note: "参考 ISO 9044 与 ASTM E2016 标准制造。"
  },
  es: {
    eyebrow: "Soporte de ingeniería de filtración",
    heading: "Solicite presupuesto o consulte a nuestro equipo de ingeniería",
    lead: "Consulte tolerancias de apertura, tipos de tejido personalizados, mallas sinterizadas multicapa o planes de suministro directamente con nuestros especialistas.",
    secondaryLabel: "Contacte con nosotros",
    note: "Fabricado con referencia a las normas ISO 9044 y ASTM E2016."
  },
  de: {
    eyebrow: "Filtrationstechnik-Support",
    heading: "Angebot anfragen oder unser Ingenieurteam konsultieren",
    lead: "Besprechen Sie Maschenweiten-Toleranzen, Webearten, mehrlagige Sintergewebe oder Lieferpläne direkt mit unseren Filtrationsspezialisten.",
    secondaryLabel: "Kontakt aufnehmen",
    note: "Hergestellt unter Bezugnahme auf ISO 9044 und ASTM E2016."
  },
  fr: {
    eyebrow: "Support d'ingénierie de filtration",
    heading: "Demandez un devis ou consultez notre équipe d'ingénierie",
    lead: "Échangez directement avec nos spécialistes sur les tolérances d'ouverture, les tissages sur mesure, les toiles frittées multicouches ou les plannings de livraison.",
    secondaryLabel: "Nous contacter",
    note: "Fabriqué en référence aux normes ISO 9044 et ASTM E2016."
  },
  pt: {
    eyebrow: "Suporte de engenharia de filtração",
    heading: "Solicite um orçamento ou consulte nossa equipe técnica",
    lead: "Discuta tolerâncias de abertura de malha, tipos de tecelagem, configurações sinterizadas multicamadas ou cronogramas de fornecimento diretamente com nossos especialistas.",
    secondaryLabel: "Fale conosco",
    note: "Fabricado com referência às normas ISO 9044 e ASTM E2016."
  }
};
export default function EngineeringConsultationCta() {
  const {
    lang
  } = useLanguage();
  const copy = pick(lang, copyData);
  return <CtaBand id="engineeringconsultationcta" eyebrow={copy.eyebrow} heading={copy.heading} lead={copy.lead} primary={{
    label: pick(lang, COMMON.requestQuote),
    to: "/RequestAQuotePage"
  }} secondary={{
    label: copy.secondaryLabel,
    to: "/ContactPage"
  }} note={copy.note} />;
}